import React from "react";

const SubMenu2 = () => {
  return (
    <div id="sub_visual" className="">
      <div className="subtop subtop_business"></div>
      <div className="v_txt">
        <h2 data-splitting="">BUSINESS</h2>
        <div className="line"></div>
        <p>The Best Leader of Information Technology</p>
      </div>
    </div>
  );
};

export default SubMenu2;
